import {Module} from "vuex";
import {ISimpleDateModel} from "../../common/common-models";
import type { IRootState } from "../../store/root-state";


export enum RESULTS_STORE_CONST {
  RESULTS_CONST_MODULE_NAME = "RESULTS_CONST_MODULE_NAME",

  // <MUTATIONS>
  RESULTS_MUTATIONS_SET_DATE = "RESULTS_MUTATIONS_SET_DATE"
  // </MUTATIONS>

}

export interface IResultsStoreState {
  dateSelected: ISimpleDateModel;
}

const mutations = {
  [ RESULTS_STORE_CONST.RESULTS_MUTATIONS_SET_DATE ](state: IResultsStoreState, dateSelected: ISimpleDateModel) {
    state.dateSelected = dateSelected;
  }
};

const getters = {
};

const actions = {
};


/**
 * Default state factory for results store
 * This replaces the inline state definition and ensures pure state initialization
 */
function getDefaultResultsState(): IResultsStoreState {
  return {
    dateSelected: {
      iso: "",
      display: "",
    },
  };
}

/**
 * Create results store module with dependency injection
 */
export function createResultsStore(
  serviceContainer: any
): Module<IResultsStoreState, IRootState> {
  return {
    namespaced: true,
    state: getDefaultResultsState(),
    mutations,
    getters,
    actions,
  };
}

// Legacy export for backward compatibility (will be removed after full migration)
export const resultsStore: Module<IResultsStoreState, IRootState> = {
  namespaced: true,
  state: getDefaultResultsState(),
  mutations,
  getters,
  actions,
};

